module.exports = __webpack_public_path__ + "static/media/RachelCookFoundation_LogoHoriz_color.78d75466.png";